/**
 * autosize.directive.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Directive, ElementRef, HostListener, Input, OnInit }
    from "@angular/core";

@Directive({
    selector: "textarea[autosize]"
})
export class AutosizeDirective implements OnInit
{
    @Input()
    public minimum : number = 34;

    @Input()
    private autosize : string;

    public expandOnly : boolean = false;

    public static StartupRecheckDelay : number = 300;

    constructor (public element : ElementRef) {}

    public ngOnInit () : void
    {
        if (this.autosize === "expand")
        {
            this.expandOnly = true;
        }
        this.resize();

        if (AutosizeDirective.StartupRecheckDelay)
        {
            setTimeout(
                () => this.resize(),
                AutosizeDirective.StartupRecheckDelay);
        }
    }

    @HostListener("input")
    private resize () : void
    {
        const textarea : HTMLTextAreaElement = this.element.nativeElement;
        if (!this.expandOnly)
        {
            // First shrink it to its minimum
            textarea.style.height = `${this.minimum}px`;
        }
        // Then expand as necessary for scrolling
        const height : number = Math.max(
            textarea.scrollHeight + 2,
            this.minimum);
        textarea.style.height = `${height}px`;
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/controls/autosize.directive.ts